import { render, staticRenderFns } from "./clazzInfo.vue?vue&type=template&id=23e97c3e&scoped=true&"
import script from "./clazzInfo.vue?vue&type=script&lang=js&"
export * from "./clazzInfo.vue?vue&type=script&lang=js&"
import style0 from "./clazzInfo.vue?vue&type=style&index=0&id=23e97c3e&scoped=true&lang=less&"
import style1 from "./clazzInfo.vue?vue&type=style&index=1&id=23e97c3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e97c3e",
  null
  
)

export default component.exports